/**
 * 调整文本元素的行数显示和省略效果
 * @param {boolean} enable - 是否启用省略显示
 * @param {HTMLElement} textElement - 包含文本的元素
 * @param {HTMLElement} containerElement - 包含文本元素的容器元素
 * @param {number} [specifiedLines] - 指定的行数（可选）
 */
export const manageLineClamp = (enable, textElement, containerElement, specifiedLines = null) => {
  if (!textElement || !containerElement) return

  if (enable) {
    const textHeight = containerElement.offsetHeight
    const computedStyle = window.getComputedStyle(textElement)
    const lineHeight = parseFloat(computedStyle.lineHeight)

    // 如果没有指定行数，自动计算行数
    let lines
    if (specifiedLines !== null) {
      lines = specifiedLines
    } else {
      // 获取内边距、外边距和边框的高度
      const paddingTop = parseFloat(computedStyle.paddingTop)
      const paddingBottom = parseFloat(computedStyle.paddingBottom)
      const borderTop = parseFloat(computedStyle.borderTopWidth)
      const borderBottom = parseFloat(computedStyle.borderBottomWidth)

      // 计算有效的行高
      const effectiveLineHeight = lineHeight + paddingTop + paddingBottom + borderTop + borderBottom

      // 计算行数
      lines = Math.floor(textHeight / effectiveLineHeight)
    }

    textElement.style.webkitLineClamp = lines
    textElement.style.lineClamp = lines
    textElement.style.display = '-webkit-box'
    textElement.style.webkitBoxOrient = 'vertical'
    textElement.style.BoxOrient = 'vertical'
    textElement.style.overflow = 'hidden'
    textElement.style.textOverflow = 'ellipsis'
  } else {
    textElement.style.removeProperty('webkit-line-clamp')
    textElement.style.removeProperty('line-clamp')
    textElement.style.removeProperty('display')
    textElement.style.removeProperty('webkit-box-orient')
    textElement.style.removeProperty('box-orient')
    textElement.style.removeProperty('overflow')
    textElement.style.removeProperty('text-overflow')
    textElement.style.removeProperty('o-text-overflow')
    textElement.style.removeProperty('ms-text-overflow')
  }
}
